import { z } from 'zod';
import { APPROVAL_STATUSES, FILE_KINDS } from '../domain';

export const approvalRequestInput = z.object({
  fileId: z.uuid(),
  /** Versão a aprovar; sem ela, a atual. */
  versionId: z.uuid().optional(),
  message: z.string().trim().max(2000).optional(),
});

export const approvalDecisionInput = z
  .object({
    decision: z.enum(['approved', 'changes_requested', 'rejected']),
    comment: z.string().trim().max(4000).default(''),
  })
  .refine((v) => v.decision === 'approved' || v.comment.length > 0, {
    message: 'Conte o que precisa mudar',
    path: ['comment'],
  });

/** Decisão pelo link público: quem está decidindo informa o nome. */
export const publicApprovalDecisionInput = z
  .object({
    decision: z.enum(['approved', 'changes_requested', 'rejected']),
    comment: z.string().trim().max(4000).default(''),
    name: z.string().trim().min(2, 'Seu nome').max(120),
  })
  .refine((v) => v.decision === 'approved' || v.comment.length > 0, {
    message: 'Conte o que precisa mudar',
    path: ['comment'],
  });

export const approvalDto = z.object({
  id: z.uuid(),
  status: z.enum(APPROVAL_STATUSES),
  file: z.object({
    id: z.uuid(),
    name: z.string(),
    kind: z.enum(FILE_KINDS),
    thumbnailUrl: z.string().nullable(),
    url: z.string(),
  }),
  versionId: z.uuid(),
  versionNumber: z.number(),
  project: z.object({ id: z.uuid(), name: z.string() }).nullable(),
  message: z.string().nullable(),
  requestedBy: z.string().nullable(),
  requestedAt: z.string(),
  decidedBy: z.string().nullable(),
  decidedAt: z.string().nullable(),
  comment: z.string().nullable(),
  /** Decidida pelo link público (sem conta). */
  viaLink: z.boolean(),
});
export type ApprovalDto = z.infer<typeof approvalDto>;

export const approvalListQuery = z.object({
  fileId: z.uuid().optional(),
  projectId: z.uuid().optional(),
  status: z.enum(APPROVAL_STATUSES).optional(),
});
